import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=546413cb&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=546413cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546413cb",
  null
  
)

export default component.exports